import './product-list.scss';

class ProductList {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-productlist',
            headlineAttr: 'headline'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$productList = $element;
        this.$productListHeadline = this.$productList.querySelector('[' + this.settings.initAttr + '="' + this.settings.headlineAttr + '"]');

        this.resizeHandler = window.resizeHandler;
        this.resizeTimeout = null;

        this.initialize();
    }

    initialize () {
        if (this.$productListHeadline) {
            this.checkSize();
            this.resizeHandler.customFunctions.push(() => {
                this.checkSize();
            });
        }
    }

    checkSize () {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = window.setTimeout(() => {
            this.calculateHeadline();
        }, 100);
    }

    calculateHeadline () {
        const headlineAPI = this.$productListHeadline.API;
        const headlineElement = headlineAPI.fittyElement;
        const compStyles = window.getComputedStyle(headlineElement);
        const fontSize = parseInt(compStyles.getPropertyValue('font-size'));

        this.$productList.style.paddingTop = fontSize * 0.25 + 'px';
        this.$productList.style.minHeight = this.$productListHeadline.offsetHeight + 'px';
    }
}

export { ProductList };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$productList = $context.querySelectorAll('[data-productList="root"]');
        for (let i = 0; i < $$productList.length; i++) {
            const $productList = $$productList[i];

            const productListAPI = new ProductList($productList);
            $productList.API = productListAPI;
        }
    }
});
